import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '.';
import { AuthPayload } from '@/utils/types';
import { handleGlobalSearch } from '@/utils';

export const attendeeApi = createApi({
	reducerPath: 'attendeeApi',
	tagTypes: ['attendees', 'attendee', 'session-attendees'],
	baseQuery: baseQuery,
	endpoints: (builder) => ({
		register: builder.mutation({
			query: (body: any) => ({
				url: `registration`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['attendee'],
		}),
		checkRegistration: builder.mutation({
			query: (body: any) => ({
				url: `registration/check`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['attendee'],
		}),
		getSessionAttendeeAction: builder.query({
			query: ({ page, sessionId }: { page: number; sessionId: string }) => ({
				url: `attendees-actions`,
				params: { page, sessionId },
			}),
			providesTags: ['session-attendees'],
		}),
		// getAttendeeAction: builder.query({
		// 	query: ({ eventId, id }: { id: string; eventId: string }) => ({
		// 		url: `attendee/${id}/actions/${eventId}`,
		// 	}),
		// }),
		addAction: builder.mutation({
			query: (body: any) => ({
				url: `attendees-actions`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['session-attendees'],
		}),
		getAttendees: builder.query({
			query: ({ page, filters }: { page: number; filters: any }) => ({
				url: `attendee`,
				params: { page, ...handleGlobalSearch(filters, ['name']) },
			}),
			providesTags: ['attendees'],
		}),
	}),
});

export const {
	useGetAttendeesQuery,
	useRegisterMutation,
	useCheckRegistrationMutation,
	useAddActionMutation,
	useGetSessionAttendeeActionQuery,
} = attendeeApi;
